import script from "./feature-release.vue?vue&type=script&lang=ts&setup=true"
export * from "./feature-release.vue?vue&type=script&lang=ts&setup=true"

import "./feature-release.vue?vue&type=style&index=0&id=adaf326c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adaf326c"]])

export default __exports__